module.exports={
	"Form": "DocumentApprovalWorkflowEditManifest",
	"Scope": "DocumentApprovalWorkflow-Edit",
	"Descriptors":
	{
		"DocumentApprovalWorkflowDetails.IDDocumentApprovalWorkflow":
		{
			"Name": "ID",
			"Hash": "DocWfEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "DocWfEditIdentity",
				"Group": "DocWfEditIdentity"
			}
		},
		"DocumentApprovalWorkflowDetails.Name":
		{
			"Name": "Transition Name",
			"Hash": "DocWfEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "DocWfEditIdentity",
				"Group": "DocWfEditIdentity"
			}
		},
		"DocumentApprovalWorkflowDetails.FromStatus":
		{
			"Name": "From Status",
			"Hash": "DocWfEdit-FromStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "DocWfEditConfig",
				"Group": "DocWfEditConfig"
			}
		},
		"DocumentApprovalWorkflowDetails.ToStatus":
		{
			"Name": "To Status",
			"Hash": "DocWfEdit-ToStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "DocWfEditConfig",
				"Group": "DocWfEditConfig"
			}
		},
		"DocumentApprovalWorkflowDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "DocWfEdit-IDProject",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 4,
				"Section": "DocWfEditConfig",
				"Group": "DocWfEditConfig"
			}
		},
		"DocumentApprovalWorkflowDetails.EdgeOptions":
		{
			"Name": "Edge Options (JSON)",
			"Hash": "DocWfEdit-EdgeOptions",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "DocWfEditEdgeOptions",
				"Group": "DocWfEditEdgeOptions"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "DocWfEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "DocWfEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Workflow Configuration",
			"Hash": "DocWfEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Workflow Configuration",
					"Hash": "DocWfEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Edge Options",
			"Hash": "DocWfEditEdgeOptions",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Edge Options",
					"Hash": "DocWfEditEdgeOptions",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
